import { render, staticRenderFns } from "./RealTimeTable.vue?vue&type=template&id=1a726af3&scoped=true"
import script from "./RealTimeTable.vue?vue&type=script&lang=js"
export * from "./RealTimeTable.vue?vue&type=script&lang=js"
import style0 from "./RealTimeTable.vue?vue&type=style&index=0&id=1a726af3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a726af3",
  null
  
)

export default component.exports